"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.QuoteName = exports.QuoteCopy = exports.QuoteCopyColumn = exports.Quotation = exports.QuoteImage = exports.QuoteGrid = exports.QuoteWrapper = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _Image = _interopRequireDefault(require("../Image"));

var _mediaQueries = _interopRequireDefault(require("../../styles/mediaQueries"));

var _Layout = require("../Layout");

var _Typography = require("../Typography");

var QuoteWrapper = (0, _styled.default)('div')(function (_ref) {
  var _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      quotes = _ref$theme.quotes,
      variant = _ref.variant;
  return _defineProperty({
    backgroundColor: variant === 'primary' ? colors.primary : 'transparent',
    padding: variant === 'primary' ? "".concat(quotes.wrapperPaddingMobile, " 0") : 0,
    color: variant === 'primary' ? colors.white : 'inherit'
  }, _mediaQueries.default.medium, {
    padding: variant === 'primary' ? "".concat(quotes.wrapperPaddingDesktop, " 0") : 0
  });
});
exports.QuoteWrapper = QuoteWrapper;
var QuoteGrid = (0, _styled.default)(_Layout.Grid)(function (_ref3) {
  var quotes = _ref3.theme.quotes,
      image = _ref3.image;
  return {
    flexDirection: image ? ['column', 'row'] : 'row',
    justifyContent: quotes.justifyQuoteGrid,
    alignItems: quotes.alignQuoteGrid,
    textAlign: 'left'
  };
});
exports.QuoteGrid = QuoteGrid;
var QuoteImage = (0, _styled.default)(_Image.default)(function (_ref4) {
  var _ref5;

  var space = _ref4.theme.space;
  return _ref5 = {
    width: '100%',
    height: 'auto',
    paddingBottom: '100%',
    marginBottom: space.base
  }, _defineProperty(_ref5, _mediaQueries.default.small, {
    marginBottom: space.medium
  }), _defineProperty(_ref5, _mediaQueries.default.medium, {
    marginBottom: space.large
  }), _defineProperty(_ref5, '&::before, &::after', {
    backgroundClip: 'padding-box',
    overflow: 'hidden',
    borderRadius: '50%'
  }), _ref5;
});
exports.QuoteImage = QuoteImage;
var Quotation = (0, _styled.default)('div')(function (_ref6) {
  var quotes = _ref6.theme.quotes;
  return {
    position: 'relative',
    '&::before': _defineProperty({
      content: "'\"'",
      display: 'inline-lock',
      textAlign: 'right',
      fontSize: '10rem',
      position: 'absolute',
      top: '3.5rem',
      right: '-1.5rem',
      lineHeight: 0
    }, _mediaQueries.default.medium, {
      fontSize: quotes.quoteIconSizeDesktop,
      lineHeight: 1,
      top: quotes.quoteIconTopDesktop
    })
  };
});
exports.Quotation = Quotation;
var QuoteCopyColumn = (0, _styled.default)(_Layout.Column)(function (_ref7) {
  var quotes = _ref7.theme.quotes,
      image = _ref7.image;
  return _defineProperty({
    textAlign: 'left'
  }, _mediaQueries.default.medium, {
    textAlign: image ? quotes.textAlignImage : quotes.textAlignNoImage
  });
});
exports.QuoteCopyColumn = QuoteCopyColumn;
var QuoteCopy = (0, _styled.default)(_Typography.Body)(function (_ref9) {
  var quotes = _ref9.theme.quotes;
  return {
    fontWeight: quotes.copyFontWeight,
    marginBottom: quotes.copyMarginBottom
  };
});
exports.QuoteCopy = QuoteCopy;
var QuoteName = (0, _styled.default)(_Typography.Body)(function (_ref10) {
  var quotes = _ref10.theme;
  return {
    fontWeight: quotes.copyFontWeight
  };
});
exports.QuoteName = QuoteName;